import { env } from "env";
import { getLocalStorageAccessToken } from "utils/helpers/localStorage";
import { getMemAppToken } from "utils/helpers/project";

export enum PacItemType {
  PAC,
  BallonPrimaire,
  BallonSerpentine,
  BallonECS,
  Pompe,
  EchangeurAPlaque,
}

export const getPACRows = (pac: Accessoire) => {
  const {
    code,
    hp_puissance7_35,
    hp_fluid_type,
    hp_temperature_maxi,
    hp_acoustic_power,
    hp_scop35_55,
  } = pac;

  return [
    { label: "FO_INFO_REF", value: code },
    { label: "FO_PRODUCT_HP_POWER@7-35", value: hp_puissance7_35 },
    { label: "FO_PRODUCT_HP_FLUID_TYPE", value: hp_fluid_type },
    { label: "FO_PRODUCT_HP_MAXI_TEMP", value: hp_temperature_maxi },
    { label: "FO_PRODUCT_HP_ACOUSTIC_POWER", value: hp_acoustic_power },
    { label: "FO_PRODUCT_HP_SCOP@35-55", value: hp_scop35_55 },
  ];
};
export const getBallonRows = (ballon: Accessoire, itemType?: PacItemType) => {
  const {
    code,
    type,
    stockage_capacite_utile,
    puissance_echangeur,
    stockBallPrim_pression_service,
    stockECS_type_BR_TH,
    stockECS_pression_service,
    stockBallPrep_pression_service,
    stockage_tapping_diameter,
    stockage_flange_number,
    stockage_jaquette,
    stockBAllPrep_type_BR_TH,
  } = ballon;

  const resultRows = [
    { label: "FO_INFO_REF", value: code },
    { label: "FO_PRODUCT_TANK_TYPE", value: getBallonTypeKey(type) },
    { label: "FO_INFO_REAL_CAPACITY", value: stockage_capacite_utile },
  ];

  if (itemType == PacItemType.BallonSerpentine) {
    resultRows.push({ label: "FO_INFO_POWER", value: puissance_echangeur });
  }
  const precionService = (() => {
    switch (itemType) {
      case PacItemType.BallonPrimaire:
        return stockBallPrim_pression_service;
      case PacItemType.BallonSerpentine:
        return stockBallPrep_pression_service;
      case PacItemType.BallonECS:
        return stockECS_pression_service;
    }
  })();

  resultRows.push(
    { label: "FO_INFO_OP_PRESSURE", value: precionService },
    {
      label: "FO_PRODUCT_CONNECTION_DIAMETER",
      value: stockage_tapping_diameter,
    },
    {
      label: "FO_PRODUCT_BUFFER_OPENINGS_NUMBER",
      value: stockage_flange_number,
    }
  );

  const infoManhole = (() => {
    switch (itemType) {
      case PacItemType.BallonSerpentine:
        return stockBAllPrep_type_BR_TH;
      case PacItemType.BallonECS:
        return stockECS_type_BR_TH;
    }
  })();
  if (!!infoManhole) {
    resultRows.push({
      label: "FO_INFO_MANHOLE",
      value:
        infoManhole === "BR"
          ? "no"
          : infoManhole === "TH"
            ? "yes"
            : infoManhole,
    });
  }
  resultRows.push({ label: "FO_PRODUCT_INSULATION", value: stockage_jaquette });
  return resultRows;
};

export const getAppointRows = (item: Accessoire) => {
  const { code, hpaux_intensity, hpaux_power } = item;

  const resultRows = [
    { label: "FO_INFO_REF", value: code },
    { label: "FO_INFO_POWER", value: hpaux_power },
    { label: "FO_INFO_INTENSITY", value: hpaux_intensity },
  ];

  return resultRows;
};
export const getEchangeurAPlaquesRows = (item: Accessoire) => {
  const {
    code,
    puissance_echangeur,
    exchange_nb_primaire_circ,
    exchange_nb_secondaire_circ,
    exchange_service_pressure_prim,
    exchange_service_pressure_sec,
  } = item;

  const resultRows = [
    { label: "FO_INFO_REF", value: code },
    { label: "FO_INFO_POWER", value: puissance_echangeur },
    { label: "FO_PRODUCT_NB_CIRC_PRIM", value: exchange_nb_primaire_circ },
    { label: "FO_PRODUCT_NB_CIRC_SEC", value: exchange_nb_secondaire_circ },
    {
      label: "FO_PRODUCT_PRIM_PRESSURE",
      value: exchange_service_pressure_prim,
    },
    { label: "FO_PRODUCT_SEC_PRESSURE", value: exchange_service_pressure_sec },
  ];

  return resultRows;
};

export const getPumpRows = (item: Accessoire) => {
  const { code, pompe_simple, pompe_marque, pompe_debit_maxi } = item;

  const resultRows = [
    { label: "FO_INFO_REF", value: code },
    { label: "FO_INFO_PUMP_HYGIA", value: pompe_simple },
    { label: "FO_INFO_PUMP_BRAND", value: pompe_marque },
    { label: "FO_INFO_MAXIMUM_FLOW", value: pompe_debit_maxi },
  ];

  return resultRows;
};

export const getAccessoireRows = (item: Accessoire) => {
  const { code } = item;

  const resultRows = [{ label: "FO_INFO_REF", value: code }];
  return resultRows;
};

export const getSolutionNomDeProposition = (solution: Solution) => {
  const pac = solution.panier.find((item) => item.tag === "HP");
  return `${pac?.quantite} ${pac?.nom}`;
};
export const getSolutionCodeDeProposition = (solution: Solution) => {
  const pac = solution.panier.find((item) => item.tag === "HP");
  return `${pac?.quantite} ${pac?.code}`;
};

export const getSolutionNomDePropositionFromPanier = (
  panier?: Accessoire[]
) => {
  if (panier) {
    const pac = panier.find((item) => item.tag === "HP");
    return `${pac?.quantite} ${pac?.nom}`;
  }
};

export const getEncodedSolutionID = (solution: Solution) => {
  return encodeURIComponent(getSolutionID(solution));
};

export const getSolutionID = (solution: Solution) => {
  //  const pac = solution.panier.find((item) => item.tag === "HP");
  return getSolutionNomDeProposition(solution);
};

export const getSolutionIDByCode = (solution: Solution) => {
  return getSolutionCodeDeProposition(solution);
};

export const getSolutionName = (id?: string) => {
  //   const pac= solution.panier.find(item=>item.tag==='HP');
  return id?.split(" ").splice(1).join(" ") ?? "";
};

export const getSchemaUrl = (code_schema: string) => {
  return env.api_url + "/api/images/GetSchema/" + code_schema;
};

export const downloadSchemaUrl = (code_schema: string) => {
  return env.api_url + "/api/images/downloadSchema/" + code_schema;
};

export const getBlobUrl = async (link: string) => {
  let token = getLocalStorageAccessToken();
  if (!token) {
    token = getMemAppToken();
  }

  const response = await fetch(link, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to download: ${response.status}`);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);

  return url;
};

export const getDownloadButtonTitleKey = (
  fileType: string,
  isDownloadButton: boolean = false
) => {
  switch (fileType.toLocaleLowerCase()) {
    case "pdf":
      return isDownloadButton
        ? `FO_UPLOAD_SCHEMA_HYDRO_${fileType.toUpperCase()}`
        : `FO_UPLOAD_DOC_${fileType.toUpperCase()}`;
    case "dwg":
    case "word":
    case "web":
    case "bim":
    case "bart":
    default:
      return `FO_UPLOAD_DOC_${fileType.toUpperCase()}`;
      ``;
  }
};

export const getPanierItemFunctionNameKeyByTag = (
  tag: "HP" | "ballonPrimaire" | "stockecs" | "stockprep" | "exchange"
) => {
  switch (tag) {
    case "HP":
      return `FO_DOC_HEAT_PUMP`;
    case "ballonPrimaire":
      return `FO_DOC_PRIMARY_TANK`;
    case "stockecs":
      return `FO_DOC_STOCK_TANK`;
    case "stockprep":
      return `FO_DOC_PREP_TANK`;
    case "exchange":
      return `FO_DOC_EXHANGE`;
  }
};

export const getBallonTypeKey = (
  type: "stockecs" | "stockprep" | "stockprim" | string | undefined
) => {
  switch (type) {
    case "stockecs":
      return `FO_INFO_TANK_ECS`;
    case "stockprep":
      return `FO_INFO_TANK_PREP`;
    case "stockprim":
      return `FO_INFO_TANK_PRIM`;
    default:
      return type;
  }
};
